var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"evaluate-list"},[_c('nav-bar',{attrs:{"fixed":"","z-index":"99","title":"评价","left-text":"返回","left-arrow":""},on:{"click-left":_vm.handleBackNavigation}}),_c('div',{staticStyle:{"height":"46px"}}),_c('div',{staticStyle:{"height":"10px"}}),_c('UserEvaluation',{attrs:{"reply":_vm.reply}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }